import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { requestNewCompanyRecoveryLinkService } from "../../services/CompanyRecovery/CompanyRecoveryServices";
import { primaryColor } from "../environment";
import "../General.css";

const RequestCompanyRecoveryLink = () => {
  const { t } = useTranslation(["common", "error"]);
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = () => {
    requestNewCompanyRecoveryLinkService({ email }).finally(() => setSent(true));
  };

  return (
    <div
      className="display-flex flex-direction-column justify-content-center align-items-center"
      style={{ height: "100vh", backgroundColor: primaryColor }}
    >
      <div className="display-flex flex-direction-column justify-content-center align-items-center signin-modal form-card">
        <div className="big-font margin-bottom">BIZalp</div>
        <div className="medium-font margin-bottom">{t("common:requestNewLinkTitle")}</div>
        {sent ? (
          <div className="small-font" style={{ marginBottom: "2rem" }}>
            {t("common:requestNewLinkSent")}
          </div>
        ) : (
          <>
            <div className="small-font" style={{ marginBottom: "2rem" }}>
              {t("common:requestNewLinkPrompt")}
            </div>
            <InputText
              placeholder="example@email.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className={classNames({ "p-inputtext-left input-text-signin": true })}
            />
            <Button
              type="submit"
              className="mt-5 signup-button"
              style={{ width: "30%" }}
              onClick={submit}
              label={t("common:sendLink")}
              disabled={email.length === 0}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default RequestCompanyRecoveryLink;
